import utils from 'utils'

class editRedInfoCtrl {
    constructor($scope, $http, $uibModal, $location, logger, httpRequest, $state, sweetalert, globalFn, redInfoService, operationService, buyerChecker, $timeout) {
        let limitNumber = 2000
        // 商品行阈值
        httpRequest.get_getLimitNumber().then((res) => {
            if (res.data.success) {
                limitNumber = res.data.value
            }
        })
        // 字典
        $scope.dictData = {}
        const typecodeArrStr = '["red_info_applicant","red_info_status","red_info_workflow_status","is_pass","inv_type","approve_status","bill_status","invoice_nature","tax_includ","is_privilege","zero_tax","is_list","invoice_status","yes_no_flag","red_info_source","red_invoice_status"]'
        const typecodeArr = ['red_info_applicant', 'red_info_status', 'red_info_workflow_status', 'is_pass', 'inv_type', 'approve_status', 'bill_status', 'invoice_nature', 'tax_includ', 'is_privilege', 'zero_tax', 'is_list', 'invoice_status', 'yes_no_flag', 'red_info_source', 'red_invoice_status']
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = $scope.dictData[typecodeArr[i]]
                arr.push({
                    enumTypeCode: null,
                    enumName: '全部',
                    enumCode: ''
                })
                arr.reverse()
                $scope.dictData[typecodeArr[i]] = arr
            }
            // 新增和编辑页面的申请人
            $scope.dictData.red_info_applicantinfo = $scope.dictData.red_info_applicant.slice(1)
        })
        // 初始化表单数据
        $scope.invoiceCodeLabel = '对应蓝字专用发票代码'
        $scope.invoiceNumberLabel = '号码'
        const _infoId = $state.params.infoId
        $scope.selectedRows = []
        if (_infoId === 'undefined') {
            $location.path('/redInfo/list').replace()
        }
        let redAmount = 0 // 可红冲金额
        let redTax = 0 // 可红冲税额
        let blueflag = false // 是否查找蓝票
        let quota = 0
        const quotasObj = {
            0: 0,
            2: 0,
            51: 0,
        }
        // 专票代码
        const invoiceCodeReg = /^[\d]{10}$/
        // 发票号码校验
        const invoiceNumReg = /^[\d]{8}$/
        let blueBill = {}

        function init() {
            $scope.param = {
                adValoremTotal: 0,
                applicant: '1',
                applyReason: '',
                billCode: '',
                billId: '',
                blueInvoiceCode: '',
                blueInvoiceNumber: '',
                busSysId: '',
                busSysName: '',
                checker: '',
                createUser: $scope.userInfo.user.realName,
                custAddress: '',
                custBank: '',
                custBankAccount: '',
                custCreditCode: '',
                custMobile: '',
                custName: '',
                custPhone: '',
                description: '',
                diskCode: '',
                diskId: 0,
                extendInfo: '',
                infoCode: '',
                infoId: _infoId,
                infoSerialNo: '',
                infoSource: '',
                infoStatus: 'TZD0500',
                invoiceCode: '',
                invoiceNumber: '',
                isBlueList: '',
                isChineseSecurity: $scope.userInfo.sale.isChineseSecurity,
                isPrint: '',
                matName: '',
                openPeople: $scope.userInfo.user.realName,
                payee: '',
                projectId: '',
                projectName: '',
                remark: '',
                saleAddress: $scope.userInfo.sale.registerAddress + ' ' + $scope.userInfo.sale.phone,
                salePhone: '',
                saleBank: $scope.userInfo.sale.saleBankAccount && $scope.userInfo.sale.saleBankAccount.bankAndccount,
                saleBankAccount: '',
                saleCreditCode: $scope.userInfo.sale.saleCreditCode,
                saleId: $scope.userInfo.sale.saleId,
                saleName: $scope.userInfo.sale.saleName,
                signature: '',
                statusDescribe: '',
                taxRate: '',
                tenantId: 0,
                totalAmt: 0,
                totalTaxamt: 0,
                ukeyCode: '',
                ukeyId: 0,
                workflowStatus: '0',
                isTax: '1',
                ovatRedDetailDTOList: [{
                    adValoremTotal: '',
                    amount: '',
                    balance: 0,
                    extendInfo: '',
                    infoDetailId: '',
                    infoId: '',
                    isPrivilege: '',
                    isTax: '',
                    matName: '',
                    ownCoding: '',
                    price: '',
                    privilegeType: '',
                    quantity: '',
                    revenueCode: '',
                    revenueName: '',
                    revenueVersion: '',
                    serialNo: 0,
                    spec: '',
                    taxAmount: '',
                    taxPrice: '',
                    taxRate: 0,
                    tenantId: 0,
                    unit: '',
                    zeroTax: '',
                }],
            }
            redAmount = 0 // 可红冲金额
            redTax = 0 // 可红冲税额
            blueflag = false // 是否查找蓝票
            quota = 0
            // 税率默认含税
            $scope.isTaxText = '含税'
            // 开票点数据
            $scope.ukeyList = $scope.userInfo.sysUkeyList
            if ($scope.ukeyList != null && $scope.ukeyList.length > 0) {
                const _ukeyList0 = $scope.ukeyList[0]
                $scope.param.ukeyId = _ukeyList0.ukeyId
                $scope.param.ukeyCode = _ukeyList0.ukeyCode
                $scope.param.diskCode = _ukeyList0.diskCode
                $scope.param.diskId = _ukeyList0.diskId
                // 三个人
                $scope.param.payee = _ukeyList0.defaultPayee
                $scope.param.checker = _ukeyList0.defaultReviewer
                httpRequest.get_getTaxDisk($scope.param.ukeyId).then((res) => {
                    const _data = res.data
                    if (!_data.success) {
                        return
                    }
                    quotasObj['0'] = _data.value.specialQuota
                    quotasObj['2'] = _data.value.generalQuota
                    quotasObj['51'] = _data.value.electronicQuota
                    quota = quotasObj[$scope.param.invType]
                    // 金税盘机器号
                    $scope.param.diskNo = _data.value.diskNo
                })
            }
        }
        init()
        // 获取单条信息
        httpRequest.get_getOvatRedInfoById({
            infoId: _infoId,
        }).then((res) => {
            if (res.data.value.infoStatus == 'TZD0000') $scope.notEdit = true
            // $scope.param = $.extend({}, $scope.param, res.data.value)
            let result=res.data.value;
            Object.keys(result).forEach(key=>{
                if((!result[key]&&!$scope.param[key])||result[key]){
                    $scope.param[key]=result[key]
                }
            })
            $scope.param.saleBank = ($scope.param.saleBank + ' ' + $scope.param.saleBankAccount).trim()
            $scope.param.saleBankAccount = ''
            $scope.param.saleAddress = ($scope.param.saleAddress + ' ' + $scope.param.salePhone).trim()
            $scope.param.salePhone = ''
            $scope.exApplicant = $scope.param.applicant
            if (!$scope.param.ukeyId && $scope.param.ukeyId !== 0) $scope.param.ukeyId = JSON.parse(localStorage.user_info).sysUkeyList[0].ukeyId
            // 开票人
            $scope.param.openPeople = $scope.userInfo.user.realName
            // 提交状态
            if ($scope.param.isSubmit === null) {
                $scope.param.isSubmit = '0'
            }
            $scope.param.workflowStatus = '0'
            calTotalAmtTotalTaxamt()
            taxChange($scope.param.isTax)
            redAmount = $scope.param.redAmount
            redTax = $scope.param.redTax
            blueBill = $.extend({}, res.data.value)
            // 此处只处理小数点问题
            const {
                ovatRedDetailDTOList
            } = $scope.param
            if (ovatRedDetailDTOList != null && ovatRedDetailDTOList != undefined && ovatRedDetailDTOList.length != 0) {
                for (let i = 0, l = ovatRedDetailDTOList.length; i < l; i++) {
                    getGoodsInfoTax(ovatRedDetailDTOList[i].revenueCode, ovatRedDetailDTOList[i].privilegeType, i)
                    ovatRedDetailDTOList[i].amount = _toFixed(ovatRedDetailDTOList[i].amount, 2)
                    ovatRedDetailDTOList[i].adValoremTotal = _toFixed(ovatRedDetailDTOList[i].adValoremTotal, 2)
                    ovatRedDetailDTOList[i].taxAmount = _toFixed(ovatRedDetailDTOList[i].taxAmount, 2)
                }
            }
            $scope.remarkChange()

            setTimeout(() => {
                $('#blue-date').datetimepicker({
                    autoclose: true,
                    minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                    language: 'zh-CN',
                    format: 'yyyy-mm-dd',
                    forceParse: 0,
                    pickTime: false,
                    pickerPosition: 'bottom-right',
                })
            }, 500)
        })

        // 获取ukeyCode
        $scope.changerUkeyId = function () {
            const _ukeyList = $scope.ukeyList
            const ukeyLen = _ukeyList.length
            if (ukeyLen > 0) {
                for (let i = 0; i < ukeyLen; i++) {
                    if (_ukeyList[i].ukeyId === $scope.param.ukeyId) {
                        const _ukeyList0 = $scope.ukeyList[i]
                        $scope.param.ukeyId = _ukeyList0.ukeyId
                        $scope.param.ukeyCode = _ukeyList0.ukeyCode
                        $scope.param.diskCode = _ukeyList0.diskCode
                        $scope.param.diskId = _ukeyList0.diskId
                        $scope.param.saleBank = _ukeyList0.bank + ' ' + _ukeyList0.bankAccount // 销方开户银行 ,
                        $scope.param.saleBankAccount = '' // 销方开户银行账号
                        // 三个人
                        $scope.param.payee = _ukeyList0.defaultPayee
                        $scope.param.checker = _ukeyList0.defaultReviewer
                        $scope.param.openPeople = _ukeyList0.defaultDrawer
                        httpRequest.get_getTaxDisk($scope.param.ukeyId).then((res) => {
                            const _data = res.data
                            if (!_data.success) {
                                return
                            }
                            quotasObj['0'] = _data.value.specialQuota
                            quotasObj['2'] = _data.value.generalQuota
                            quotasObj['51'] = _data.value.electronicQuota
                            quota = quotasObj[$scope.param.invType]
                            // 金税盘机器号
                            $scope.param.diskNo = _data.value.diskNo
                        })

                        break
                    }
                }
            }
        }

        // 是否含税
        $scope.isTaxChange = taxChange

        function taxChange(v) {
            $scope.param.isTax = v
            if ($scope.param.isTax === '0') {
                $scope.isTaxText = '不含税'
            } else {
                $scope.isTaxText = '含税'
            }
        }

        // 根据蓝票号码和代码生成红字信息表
        function getRedInfoByBlueInvoice() {
            if (invoiceCodeReg.test($scope.param.blueInvoiceCode) && invoiceNumReg.test($scope.param.blueInvoiceNumber)) {
                makeRedInfo($scope.param.blueInvoiceCode, $scope.param.blueInvoiceNumber)
            }
        }

        $scope.blueInvoiceChange = function () {
            getRedInfoByBlueInvoice()
        }

        // 查找蓝票
        $scope.canBalanceMadol = true // 差额是否可用
        $scope.openCheckblue = function () {
            if ($scope.param.applicant == '2') {
                const hasPermit = operationService.hasPermit('ivat_invoice_original')
                if (!hasPermit) {
                    logger.logError("未开启进项电子底账功能，无法查找，请开启后再试")
                    return
                }
            }
            const _req = {
                pageNum: 1,
                pageSize: 5,
                orderMap: {
                    createTime: 'desc'
                },
                param: {
                    cancelDateMax: '',
                    cancelDateMin: '',
                    custCodeName: '',
                    diskCode: '',
                    invType: '0',
                    invoiceCode: '',
                    invoiceCodeNumber: '',
                    invoiceDateMax: '',
                    invoiceDateMin: '',
                    invoiceNumber: '',
                    isCancel: '0',
                    isList: '',
                    isPrint: '',
                    isRed: '0',
                    isReopen: '',
                    openPeople: '',
                    ukeyCode: '',
                    redApplicantType: $scope.param.applicant,
                    invoiceDateBegin: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`,
                    invoiceDateEnd: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
                    taxRate: '',
                },
            }
            httpRequest.post_getNormalBlueInvoice(_req).then((res) => {
                const resData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                // if (resData.length == 0) {
                //     logger.logError('没有查找到相关记录')
                //     return
                // }
                const copyInvoiceData = {}
                copyInvoiceData.list = resData
                copyInvoiceData.totalItems = res.data.value.total
                copyInvoiceData.currentPage = ++res.data.value.prePage
                copyInvoiceData.maxSize = res.data.value.pageSize
                copyInvoiceData.redApplicantType = $scope.param.applicant
                const modalInstance = $uibModal.open({
                    templateUrl: 'copyInvoiceModalContent.html',
                    controller: 'modalRedFindInvCtrl',
                    openedClass: 'mod-modal-haslist blue-invoice-list mod-modal mod-modal-so-hg',
                    backdrop: 'static',
                    resolve: {
                        items1() {
                            return copyInvoiceData
                        },
                    },
                })
                modalInstance.result.then((item) => {
                    $scope.param.blueInvoiceCode = item.invoiceCode
                    $scope.param.blueInvoiceNumber = item.invoiceNumber
                    $scope.param.blueInvoiceDate = (item.invoiceDate && item.invoiceDate.slice(0, 10)) || ''
                    // 可红冲金额
                    redAmount = item.redAmount
                    $scope.selectedRows = []
                    redTax = item.redTax
                    $scope.canBalanceMadol = false // 差额是否可用
                    getRedInfoByBlueInvoice()
                }, () => {
                    console.log(`Modal dismissed at: ${new Date()}`)
                })
            })
        }
        // 计算金额/税额合计 税价合计
        function calTotalAmtTotalTaxamt() {
            const ovatRedDetailDTOListLth = $scope.param.ovatRedDetailDTOList.length
            if (ovatRedDetailDTOListLth > 0) {
                let _totalAmt = 0
                let _totalTaxamt = 0
                for (let i = 0; i < ovatRedDetailDTOListLth; i++) {
                    _totalAmt = globalFn.Add(_totalAmt, $scope.param.ovatRedDetailDTOList[i].amount)
                    _totalTaxamt = globalFn.Add(_totalTaxamt, $scope.param.ovatRedDetailDTOList[i].taxAmount)
                }
                const _adValoremTotal = globalFn.Add(_totalAmt, _totalTaxamt)
                $scope.param.totalTaxamt = _toFixed(_totalTaxamt, 2)
                $scope.param.totalAmt = _toFixed(_totalAmt, 2)
                $scope.param.adValoremTotal = _toFixed(_adValoremTotal, 2)
                $scope.adValoremTotalChinese = globalFn.digitUppercase($scope.param.adValoremTotal)
            } else {
                $scope.param.totalAmt = 0
                $scope.param.totalTaxamt = 0
                $scope.param.adValoremTotal = 0
                $scope.adValoremTotalChinese = globalFn.digitUppercase($scope.param.adValoremTotal)
            }
        }
        calTotalAmtTotalTaxamt()
        $scope.calTotalAmtTotalTaxamt = calTotalAmtTotalTaxamt
        // 差额
        $scope.balanceMadol = function () {
            if ($scope.param.ovatRedDetailDTOList.length == 0) {
                logger.logError('请先添加商品行')
                return
            }
            const _idList = getSelectedArr($scope.param.ovatRedDetailDTOList, 'selected', 'serialNo')
            const _idListLth = _idList.length
            // 是否选中行
            if (_idListLth == 0) {
                logger.logError('请先选择商品行')
                return
            }
            if ($scope.param.ovatRedDetailDTOList.length > 1) {
                logger.logError('正常商品明细行超过1行，不能添加差额')
                return
            }
            // 税率为减按1.5%的发票不能差额
            if ($scope.param.ovatRedDetailDTOList[0].taxRate === 0.015) {
                logger.logError('税率为减按1.5%的发票不能差额！')
                return
            }
            // 选择行金额是否合法
            if (hasUnAmountArr($scope.param.ovatRedDetailDTOList, 'selected')) {
                logger.logError('您选择的商品明细中金额格式不正确!')
                return
            }
            // 弹窗
            const balanceModalData = {
                amount: $scope.param.ovatRedDetailDTOList[0].amount,
                balance: $scope.param.ovatRedDetailDTOList[0].balance,
            } // 数据
            const modalInstance = $uibModal.open({
                templateUrl: 'balanceModalContent.html',
                controller: 'modalRedInfoBalanceCtrl',
                openedClass: 'mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return balanceModalData
                    },
                },
            })
            modalInstance.result.then((item) => {
                $scope.param.ovatRedDetailDTOList[0].balance = item.balance
                let _remark = ''
                if ($scope.param.remark.indexOf('差额征税。') == -1) {
                    _remark = '差额征税。'
                }
                $scope.param.remark = _remark + $scope.param.remark
                // 重新计算税额
                const billLine = $scope.param.ovatRedDetailDTOList[0]
                const _isTax = $scope.param.isTax
                if (isTax()) {
                    var _adValoremTotal = billLine.adValoremTotal
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_adValoremTotal - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_adValoremTotal, billLine.taxRate, _isTax)
                    }
                    var _amount = globalFn.Sub(_adValoremTotal, billLine.taxAmount)
                    billLine.amount = _toFixed(_amount, 2)
                    if (isQuantity(billLine.quantity) && isPrice(billLine.taxPrice)) {
                        billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                        billLine.price = globalFn.Div(_amount, billLine.quantity)
                    }
                } else {
                    var _amount = billLine.amount
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_amount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_amount, billLine.taxRate, _isTax)
                    }
                    var _adValoremTotal = globalFn.Add(_amount, billLine.taxAmount)
                    billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                    if (isPrice(billLine.price)) {
                        billLine.quantity = globalFn.Div(_amount, billLine.price)
                        billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    }
                    if (isQuantity(billLine.quantity) && isPrice(billLine.price)) {
                        billLine.price = globalFn.Div(_amount, billLine.quantity)
                        billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    }
                }
                calTotalAmtTotalTaxamt()
            }, () => {
                console.log(`Modal dismissed at: ${new Date()}`)
            })
        }

        // 新增商品行
        $scope.operatedAdd = function () {
            // 差额征税的商品明细只能开具一行！
            // 判断商品是否为null
            const billLineArr = $scope.param.ovatRedDetailDTOList
            if (billLineArr == null || billLineArr == undefined) {
                $scope.param.ovatRedDetailDTOList = []
            }
            let bll = billLineArr.length
            if (hasBalanced()) {
                logger.logError('差额征税的商品明细只能开具一行！')
                return
            }
            if (bll >= limitNumber) {
                logger.logError(`商品行数最多不能超过${limitNumber}行！`)
                return
            }
            // 开票申请单上的商品明细行不超过8行。超过8行自动勾选清单
            const goodsMaxCol = 8
            if (bll >= goodsMaxCol) {
                logger.logError('商品明细行最多8行')
                return
            }
            $scope.param.ovatRedDetailDTOList.push({
                adValoremTotal: '',
                amount: '',
                balance: 0,
                extendInfo: '',
                infoDetailId: '',
                infoId: '',
                isPrivilege: '',
                isTax: '',
                matName: '',
                ownCoding: '',
                price: '',
                privilegeType: '',
                quantity: '',
                revenueCode: '',
                revenueName: '',
                revenueVersion: '',
                serialNo: ++bll,
                spec: '',
                taxAmount: '',
                taxPrice: '',
                taxRate: 0,
                tenantId: 0,
                unit: '',
                zeroTax: '',
            })
        }
        // 检查行是否合法
        function checkGoodsTr() {
            const _isTax = $scope.param.isTax
            if (($scope.param.applicant === '3' || $scope.param.applicant === '0') && lengthForString($scope.param.ukeyCode) == '') {
                logger.logError('请选择开票点')
                return false
            }
            if (Math.abs($scope.param.adValoremTotal) == 0 || Math.abs($scope.param.totalAmt) == 0) {
                logger.logError('发票总金额不能为0')
                return false
            }
            // if (!$scope.param.custCreditCode) {
            //     logger.logError('购方税号不能为空')
            //     return false
            // }
            // if (!globalFn.checkTax($scope.param.custCreditCode)) {
            //     logger.logError('购方税号格式不正确')
            //     return false
            // }
            if (lengthForString($scope.param.saleCreditCode) == 0 || !globalFn.checkTax($scope.param.saleCreditCode)) {
                logger.logError('销方税号格式不正确')
                return false
            }
            if (!$scope.param.saleName) {
                logger.logError('销方名称不能为空')
                return false
            }
            if (lengthForString($scope.param.custName) > 100 || lengthForString($scope.param.custName) == 0) {
                logger.logError('购方名称长度不能超过100字节，一个汉字算两个字节')
                return false
            }
            if (lengthForString($scope.param.custAddress) > 100) {
                logger.logError('购方地址电话长度不能超过100字节，一个汉字算两个字节')
                return false
            }
            if (lengthForString($scope.param.custBank) > 100) {
                logger.logError('购方银行加账号长度不能超过100字节，一个汉字算两个字节')
                return false
            }
            if (lengthForString($scope.param.saleAddress) > 100) {
                logger.logError('销方地址加电话长度不能超过100字节，一个汉字算两个字节')
                return false
            }
            if (lengthForString($scope.param.saleBank) > 100) {
                logger.logError('销方银行加账号长度不能超过100字节，一个汉字算两个字节')
                return false
            }
            // 校验销方信息、购方信息必须与对应蓝票一致
            if ($scope.param.applicant !== '1' && $scope.param.custName !== blueBill.custName) {
                logger.logError('购方名称与对应蓝票不一致.')
                return false
            }
            if ($scope.param.applicant !== '1' && $scope.param.custCreditCode !== blueBill.custCreditCode) {
                logger.logError('购方税号与对应蓝票不一致.')
                return false
            }
            // 判断商品是否为null
            const billLineArr = $scope.param.ovatRedDetailDTOList
            const bll = billLineArr.length
            if (billLineArr == null || bll == 0) {
                logger.logError('商品行不能为空！')
                return false
            }
            const refinedOils = billLineArr.filter((item) => {
                return utils.isRefinedOil(item.revenueCode)
            })
            const unRefinedOils = billLineArr.filter((item) => {
                return !!item.revenueCode && !utils.isRefinedOil(item.revenueCode)
            })
            const refinedOilLength = refinedOils.length
            const unRefinedOilLength = unRefinedOils.length
            const isRefinedOil = refinedOilLength > 0
            if (isRefinedOil && (unRefinedOilLength > 0)) {
                logger.logError('一张发票不能同时开具成品油与其他商品')
                return false
            }
            if (isRefinedOil && ($scope.param.isList === '1')) {
                logger.logError('成品油不能开具清单发票')
                return false
            }
            let maxGoods = limitNumber
            if (isRefinedOil) {
                maxGoods = 8
            }
            if (bll > maxGoods) {
                logger.logError(`商品行数最多不能超过${maxGoods}行！`)
                return false
            }
            let sewc = 0 // 税额误差
            let sumSewc = 0 // 金额总误差
            for (var i = 0; i < bll; i++) {
                if (billLineArr[i].lineNature === '1') {
                    continue
                }
                const billLine = billLineArr[i]
                const spNumVal = `第${i + 1}行`
                if (lengthForString(billLine.matName) == 0) {
                    logger.logError(`${spNumVal}商品名称不能为空`)
                    return false
                }
                if (lengthForString(billLine.matName) > 92) {
                    logger.logError(`${spNumVal}商品名称长度不能超过92字节，一个汉字算两个字节`)
                    return false
                }
                if (lengthForString(billLine.spec) > 40) {
                    logger.logError(`${spNumVal}商品规格型号长度不能超过40字节，一个汉字算两个字节`)
                    return false
                }
                if (lengthForString(billLine.unit) > 22) {
                    logger.logError(`${spNumVal}商品计量单位长度不能超过22字节，一个汉字算两个字节`)
                    return false
                }
                if (isRefinedOil && (billLine.unit !== '吨') && (billLine.unit !== '升')) {
                    logger.logError(`${spNumVal}成品油商品，计量单位必为“吨”或“升”`)
                    return false
                }
                if (isRefinedOil && (!billLine.quantity || (billLine.quantity * 1 === 0))) {
                    logger.logError(`${spNumVal}成品油商品，数量不能为空或0`)
                    return false
                }
                if (lengthForString(billLine.amount) == 0 || Math.abs(billLine.amount) == 0) {
                    logger.logError(`${spNumVal}商品金额不能为空或0`)
                    return false
                }
                if (lengthForString(billLine.taxRate) == 0) {
                    logger.logError(`${spNumVal}商品税率不能为空`)
                    return false
                }
                if (billLine.isTax === '1' && !billLine.taxPrice && billLine.quantity) {
                    logger.logError(`${spNumVal}商品数量不为空，则商品单价不能为空`)
                    return false
                }
                if (billLine.isTax === '1' && billLine.taxPrice && !billLine.quantity) {
                    logger.logError(`${spNumVal}商品单价不为空，则商品数量不能为空`)
                    return false
                }
                if (billLine.isTax !== '1' && !billLine.price && billLine.quantity) {
                    logger.logError(`${spNumVal}商品数量不为空，则商品单价不能为空`)
                    return false
                }
                if (billLine.isTax !== '1' && billLine.price && !billLine.quantity) {
                    logger.logError(`${spNumVal}商品单价不为空，则商品数量不能为空`)
                    return false
                }
                if (!isAmount(billLine.amount) || !isAmount(billLine.adValoremTotal)) {
                    logger.logError(`${spNumVal}商品金额格式不正确`)
                    return false
                }
                if (billLine.taxRate == 0.015 && billLine.balance != 0 && billLine.balance != null) {
                    logger.logError(`${spNumVal}1.5%税率不能填差额征税!`)
                    return false
                }
                if (billLine.taxRate == 0) {
                    logger.logError(`${spNumVal}专票填开不能录入税率为0的商品`)
                    return false
                }
                if (lengthForString(billLine.price) > 0 && lengthForString(billLine.quantity) > 0 && checkjewc(billLine.price, billLine.quantity, billLine.amount)) {
                    logger.logError(`${spNumVal}单价数量金额误差大于0.01`)
                    return false
                }
                let balance = 0
                if (lengthForString(billLine.balance) > 0) {
                    balance = parseFloat(billLine.balance)
                }
                if (_isTax === '1') {
                    // 判断差额发票金额不能大于差额
                    // if (hasBalanced () && globalFn.Sub(billLine.adValoremTotal,balance) > 0) {
                    //     logger.logError("差额征税的商品明细金额不能大于差额"+balance+"！");
                    //     return false;
                    // }
                    if (hasBalanced() && billLine.adValoremTotal - balance > 0) {
                        billLine.balance = billLine.adValoremTotal
                        balance = parseFloat(billLine.balance)
                    }
                    var realSewc = realTaxCalculation(billLine.adValoremTotal - balance, billLine.taxRate, _isTax)
                } else {
                    // 判断差额发票金额不能大于差额
                    // if (hasBalanced () &&  globalFn.Sub(billLine.balance,balance) > 0) {
                    //     logger.logError("差额征税的商品明细金额不能大于差额"+balance+"！");
                    //     return false;
                    // }
                    if (hasBalanced() && billLine.amount - balance > 0) {
                        billLine.balance = billLine.amount
                        balance = parseFloat(billLine.balance)
                    }
                    var realSewc = realTaxCalculation(billLine.amount - balance, billLine.taxRate, _isTax)
                }
                sewc = Math.abs(globalFn.Sub(realSewc, billLine.taxAmount))
                sumSewc = globalFn.Add(sumSewc, realSewc)
                // 红字不校验0.06
                // if(globalFn.Sub(sewc,0.06)>0){
                //     logger.logError(spNumVal + "发票金额乘以税率的值与税额的误差超过限制0.06");
                //     return false;
                // }
            }
            // 是否1.5%税率且多税率
            // 是否多税率
            let mulRate0015 = false
            const newRateArr = $scope.param.ovatRedDetailDTOList.map((item) => item.taxRate)
            if (newRateArr.length > 1 && newRateArr.indexOf(0.015) > -1) {
                for (var i = 0, l = newRateArr.length - 1; i < l; i++) {
                    if (newRateArr[i] !== newRateArr[i + 1]) {
                        mulRate0015 = true
                        break
                    }
                }
            }
            if (mulRate0015) {
                logger.logError('减按1.5计税发票不支持多税率发票开具')
                return false
            }
            // 是否超过误差
            sumSewc = _toFixed(sumSewc, 2)
            const _sumSewc = Math.abs(globalFn.Sub(sumSewc, $scope.param.totalTaxamt))
            console.log(_sumSewc)
            if (globalFn.Sub(_sumSewc, 1.27) > 0 && $scope.param.ovatRedDetailDTOList[0].taxRate != '10.02') {
                logger.logError('发票合计金额乘以税率的值与合计税额的误差超过限制1.27')
                return false
            }
            return true
        }

        // 是否差额
        function hasBalanced() {
            const {
                ovatRedDetailDTOList
            } = $scope.param
            return (ovatRedDetailDTOList.length == 1 || ovatRedDetailDTOList.length == 2) && ovatRedDetailDTOList[0].balance != 0 && ovatRedDetailDTOList[0].balance != null
        }

        // 主商品名和税率
        function matNameAndRate() {
            const ovatRedDetailDTOListLth = $scope.param.ovatRedDetailDTOList.length
            if ($scope.param.ovatRedDetailDTOList.length === 0) {
                return
            }
            $scope.param.taxRate = $scope.param.ovatRedDetailDTOList[0].taxRate
            $scope.param.matName = $scope.param.ovatRedDetailDTOList[0].matName

            // 是否多税率
            let isMulRate = false
            const newRateArr = $scope.param.ovatRedDetailDTOList.map((item) => item.taxRate)
            for (let i = 0, l = newRateArr.length - 1; i < l; i++) {
                if (newRateArr[i] !== newRateArr[i + 1]) {
                    isMulRate = true
                    break
                }
            }
            if (isMulRate) {
                $scope.param.taxRate = ''
            }
        }
        // 商品行自动补全
        $scope.qryTaxClassList = function (val, $index) {
            if (lengthForString(val) > 92) {
                $scope.param.ovatRedDetailDTOList[$index].matName = ''
                logger.logError('商品名称长度不能超过92字节，一个汉字算两个字节')
                return
            }
            return $http.post(`${host.etcloudOvat}settings/sysGoodsInfo/getGoodsInfoList`, val).then((response) => {
                const _resArr = response.data.value
                if (_resArr == null || _resArr.length == 0) {
                    $scope.param.ovatRedDetailDTOList[$index].matName = ''

                    logger.logError('未查找到相关商品')
                    return
                }
                return _resArr.map((item) => $.extend({}, {
                    goodsCodeAndGoodsName: `${item.goodsCode}<span class="typeahead-taxname">${item.goodsName}</span>` + `<span class="typeahead-taxname">${item.taxRate * 100}%</span>`,
                }, item))
            })
        }
        // 选中行
        $scope.qryTaxClassInfo = function ($item, $index) {
            $scope.param.ovatRedDetailDTOList[$index].taxRate = $item.taxRate
            $scope.param.ovatRedDetailDTOList[$index].isPrivilege = $item.isPrivilege
            $scope.param.ovatRedDetailDTOList[$index].matCode = $item.goodsCode
            $scope.param.ovatRedDetailDTOList[$index].matName = $item.goodsName
            $scope.param.ovatRedDetailDTOList[$index].typeName = $item.matCalss
            $scope.param.ovatRedDetailDTOList[$index].revenueCode = $item.taxMergeCode
            $scope.param.ovatRedDetailDTOList[$index].revenueName = $item.taxShortName
            $scope.param.ovatRedDetailDTOList[$index].revenueVersion = $item.codeVersions
            $scope.param.ovatRedDetailDTOList[$index].privilegeType = $item.privilegeType
            $scope.param.ovatRedDetailDTOList[$index].isPrivilege = $item.isPrivilege
            $scope.param.ovatRedDetailDTOList[$index].isTax = `${$item.taxInclud}`
            $scope.param.ovatRedDetailDTOList[$index].unit = $item.measureUnit
            $scope.param.ovatRedDetailDTOList[$index].spec = $item.specifications
            $scope.param.ovatRedDetailDTOList[$index].taxAmount = ''
            $scope.param.ovatRedDetailDTOList[$index].adValoremTotal = ''
            $scope.param.ovatRedDetailDTOList[$index].amount = ''
            // 获取享受优惠税率
            getGoodsInfoTax($item.taxMergeCode, $item.privilegeType, $index)
            // 简称
            $scope.param.ovatRedDetailDTOList[$index].shortAndMatName = `*${$item.taxShortName}*${$item.goodsName}`
            if ($item.price != null) {
                if ($scope.param.ovatRedDetailDTOList[$index].isTax === '1') {
                    $scope.param.ovatRedDetailDTOList[$index].taxPrice = $item.price
                    $scope.param.ovatRedDetailDTOList[$index].price = globalFn.Div($item.price, globalFn.Add(1, $item.taxRate))
                } else {
                    $scope.param.ovatRedDetailDTOList[$index].taxPrice = globalFn.Mul($item.price, globalFn.Add(1, $item.taxRate))
                    $scope.param.ovatRedDetailDTOList[$index].price = $item.price
                }
            }
        }

        // 获取商品税率
        function getGoodsInfoTax(tMc, pt, $index) {
            const billLine = $scope.param.ovatRedDetailDTOList[$index]
            const rateReq = {
                taxMergeCode: tMc,
                privilegeType: encodeURIComponent(pt),
                invType: '0',
            }
            httpRequest.get_queryGoodsTax(rateReq).then((res) => {
                const dataV = res.data.value
                const zeroTaxArr = $scope.dictData.zero_tax
                if (dataV.length > 0) {
                    billLine.taxRateArr = dataV
                }
                dataV.forEach((taxRateItem) => {
                    if (taxRateItem.privilegeType === billLine.privilegeType &&
                        taxRateItem.taxRate === billLine.taxRate) {
                        billLine.taxRateObj = taxRateItem
                    }
                })
                // 零税率标志
                for (let i = 0, l = zeroTaxArr.length; i < l; i++) {
                    if (zeroTaxArr[i].enumName === pt && billLine.taxRate == 0) {
                        billLine.zeroTax = zeroTaxArr[i].enumCode
                    }
                }
            })
        }


        // 购方模块自动补全POST /
        $scope.qryCustNameList = function (val) {
            if (lengthForString(val) > 100) {
                $scope.param.custName = ''
                logger.logError('购方名称长度不能超过100字节，一个汉字算两个字节')
                return
            }
            return $http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, val).then((response) =>
                // var _resArr = response.data.value.list;
                // if (_resArr == null || _resArr.length == 0) {
                //     $scope.param.custName = "";
                //     logger.logError('未查找到相关购方信息');
                //     return;
                // }
                response.data.value.map((item) => $.extend({}, {
                    custCodeAndcustName: `${item.customerName} ${item.creditCode}`,
                }, item)))
        }
        // 选中行
        $scope.qryCustNameInfo = function ($item, $model, $label, $event, v) {
            if(v){
                $scope.param.saleName = $item.customerName
                $scope.param.saleCreditCode = $item.creditCode
                $scope.param.saleAddress = $item.businessAddress || $item.registerAddress
                $scope.param.salePhone = $item.phone
                $scope.param.saleBank = $item.bank
                $scope.param.saleBankAccount = $item.bankAccount
                $scope.param.saleCode = $item.customerCode
                // $scope.param.creditType = $item.taxplayerType

            }else{
                $scope.param.custName = $item.customerName
                $scope.param.custCreditCode = $item.creditCode
                $scope.param.custAddress = $item.businessAddress || $item.registerAddress
                $scope.param.custPhone = $item.phone
                $scope.param.custBank = $item.bank
                $scope.param.custBankAccount = $item.bankAccount
                $scope.param.custCode = $item.customerCode
                $scope.param.creditType = $item.taxplayerType

            }
        }

        // 纳税人识别号检测
        $scope.taxNoChange = function () {
            if ($scope.param.custCreditCode !== '' && !globalFn.checkTax($scope.param.custCreditCode)) {
                logger.logError('购方纳税人识别号格式错误！')
                $scope.param.custCreditCode = ''
            }
        }

        // 销方纳税人识别号检测
        $scope.saleTaxNoChange = function () {
            if ($scope.param.saleCreditCode !== '' && !globalFn.checkTax($scope.param.saleCreditCode)) {
                logger.logError('销方纳税人识别号格式错误！')
                $scope.param.saleCreditCode = ''
            }
        }

        // 申请人变化
        $scope.applicantChange = function () {
            // 购方/销方切换
            const {
                param
            } = $scope
            const _custName = param.custName
            const _custCreditCode = param.custCreditCode
            const _custAddress = param.custAddress
            const _custPhone = param.custPhone
            const _custBank = param.custBank
            const _custBankAccount = param.custBankAccount

            const _saleName = param.saleName
            const _saleCreditCode = param.saleCreditCode
            const _saleAddress = param.saleAddress
            const _salePhone = ''
            const _saleBank = param.saleBank
            const _saleBankAccount = ''
            const _isChineseSecurity = param.isChineseSecurity

            if ($scope.exApplicant == '0' || $scope.exApplicant == '3') { // 上一选项为销方
                if ($scope.param.applicant === '1' || $scope.param.applicant === '2') {
                    // 购方
                    $scope.param.custName = _saleName
                    $scope.param.custCreditCode = _saleCreditCode
                    $scope.param.custAddress = _saleAddress
                    $scope.param.custPhone = _salePhone
                    $scope.param.custBank = _saleBank
                    $scope.param.custBankAccount = _saleBankAccount

                    // 销方
                    $scope.param.saleId = $scope.userInfo.sale.saleId
                    $scope.param.saleName = _custName
                    $scope.param.saleCreditCode = _custCreditCode
                    $scope.param.saleAddress = _custAddress
                    $scope.param.salePhone = ''
                    $scope.param.saleBank = _custBank
                    $scope.param.saleBankAccount = ''
                    $scope.param.isChineseSecurity = _isChineseSecurity
                }
            } else if ($scope.param.applicant === '0' || $scope.param.applicant === '3') { // 上一选项为购方

                // 购方
                $scope.param.custName = _saleName
                $scope.param.custCreditCode = _saleCreditCode
                $scope.param.custAddress = _saleAddress
                $scope.param.custPhone = _salePhone
                $scope.param.custBank = _saleBank
                $scope.param.custBankAccount = _saleBankAccount
                // 销方
                $scope.param.saleId = $scope.userInfo.sale.saleId
                $scope.param.saleName = _custName
                $scope.param.saleCreditCode = _custCreditCode
                $scope.param.saleAddress = _custAddress
                $scope.param.salePhone = ''
                $scope.param.saleBank = _custBank
                $scope.param.saleBankAccount = ''
                $scope.param.isChineseSecurity = $scope.userInfo.sale.isChineseSecurity

            }

            $scope.exApplicant = $scope.param.applicant

            // 不是销售方填写-其他企业作为购方申请的情况
            if ($scope.param.applicant !== '3') {
                $scope.param.infoCode = ''
                $scope.invoiceCodeLabel = '对应蓝字专用发票代码'
                $scope.invoiceNumberLabel = '号码'
                if ($scope.param.applicant !== '1') {
                    $scope.param.remark = $scope.param.remark.replace('对应正数发票代码', $scope.invoiceCodeLabel)
                }
            } else {
                $scope.invoiceCodeLabel = '对应正数发票代码'
                $scope.invoiceNumberLabel = '号码'
                $scope.param.remark = $scope.param.remark.replace('对应蓝字专用发票代码', $scope.invoiceCodeLabel)
            }
        }

        /**
         * 返回字符串的长度--中文占2个字符
         * @param temp
         * @returns
         */
        function lengthForString(temp) {
            let len = 0
            temp = $.trim(temp)
            for (let i = 0; i < temp.length; i++) {
                const c = temp.charCodeAt(i)
                // 单字节加1
                if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                    len++
                } else {
                    len += 2
                }
            }
            return len
        }

        // 是否含税
        function isTax() {
            return $scope.param.isTax === '1'
        }
        // 匹配是否正确单价
        function isPrice(v) {
            const reg_num = /^\d{1,12}(\.\d{0,15})?$/ // 金额规则 数字，小数点前12位，后15位
            return globalFn.isPositiveFloatNum(v) && parseFloat(v) !== 0 && reg_num.test(v)
        }
        // 是否正确数字
        function isQuantity(v) {
            const reg_num = /^\-\d{1,12}(\.\d{0,15})?$/ // 金额规则 数字，小数点前12位，后15位
            return globalFn.isNegativeFloatNum(v) && parseFloat(v) !== 0 && reg_num.test(v)
        }
        // 是否正确的金额
        function isAmount(v) {
            const reg_je = /^\-\d{1,12}(\.\d{0,2})?$/ // 金额规则 数字，小数点前12位，后2位
            return globalFn.isNegativeFloatNum(v) && parseFloat(v) !== 0 && reg_je.test(v)
        }

        // 精确n位小数
        function _toFixed(v, n) {
            return parseFloat(v).toFixed(n)
        }

        // 校验单条明细-0.01<=(数量*单价-金额 )<= 0.01
        function checkjewc(price, num, amount) {
            const _amount = _toFixed(globalFn.Mul(Math.abs(price), Math.abs(num)), 2)
            return globalFn.Sub(Math.abs(globalFn.Sub(_amount, Math.abs(amount))), 0.01) > 0
        }

        // 红字信息表编号
        function isInfoCode(v) {
            const _reg = /^\d{16}$/
            return _reg.test(v)
        }

        /**
         * 计算税额
         * @param amt--金额
         * @param taxrate--税率
         * @param taxFlag--含税标志
         */
        function taxCalculation(amt, taxrate, taxFlag) {
            let taxamount = 0
            if (taxFlag == '1') { // 含税
                taxamount = parseFloat(amt * taxrate / (1 + parseFloat(taxrate))).toFixed(2)
                if (taxrate == '0.015') {
                    taxamount = parseFloat(amt / 1.05 * 0.015).toFixed(2)
                }
            } else { // 不含税
                taxamount = parseFloat(amt * taxrate).toFixed(2)
                if (taxrate == '0.015') {
                    taxamount = parseFloat(amt * 0.015 / 1.035).toFixed(2)
                }
            }
            // 特殊处理税额大于0则等于0
            if (taxamount > 0) {
                taxamount = _toFixed(0, 2)
            }
            return taxamount
        }

        // 真实税额
        function realTaxCalculation(amt, taxrate, taxFlag) {
            let taxamount = 0
            if (taxFlag == '1') { // 含税
                taxamount = globalFn.Div(globalFn.Mul(amt, taxrate), globalFn.Add(1, taxrate))
                if (taxrate == '0.015') {
                    taxamount = globalFn.Mul(globalFn.Div(amt, 1.05), 0.015)
                }
            } else { // 不含税
                taxamount = globalFn.Mul(amt, taxrate)
                if (taxrate == '0.015') {
                    taxamount = globalFn.Mul(globalFn.Div(globalFn.Mul(amt, 1.015), 1.05), 0.015)
                }
            }
            // 特殊处理税额大于0则等于0
            if (taxamount > 0) {
                taxamount = _toFixed(0, 2)
            }
            return taxamount
        }

        // 规格型号
        $scope.specChange = function ($index) {
            if (lengthForString($scope.param.ovatRedDetailDTOList[$index].spec) > 40) {
                $scope.param.ovatRedDetailDTOList[$index].spec = ''
                logger.logError('规格型号不能大于40个字节')
            }
        }
        // 单位变化
        $scope.unitChange = function ($index) {
            if (lengthForString($scope.param.ovatRedDetailDTOList[$index].unit) > 22) {
                $scope.param.ovatRedDetailDTOList[$index].unit = ''
                logger.logError('单位不能大于22个字节')
            }
        }

        // 数量变化
        $scope.quantityChange = function ($index) {
            const billLine = $scope.param.ovatRedDetailDTOList[$index]
            if (billLine.taxRate == '10.02' && billLine.quantity) {
                billLine.quantity = ''
                logger.logError('请先修改税率！')
                return
            }
            if (billLine.taxRate === '') {
                billLine.quantity = ''
                logger.logError('请先录入商品！')
                return
            }
            if (globalFn.isNullVal(billLine.quantity)) {
                billLine.quantity = ''
                return
            }
            // 截取数字
            billLine.quantity = globalFn.cutOutNnumber(billLine.quantity, 15)
            const _isTax = $scope.param.isTax
            if (isTax()) {
                if (!isQuantity(billLine.quantity)) {
                    billLine.quantity = ''
                    logger.logError('数量为负数，整数部分不能大于12个数字，小数部分不能大于15个数字')
                    return
                }
                if (isPrice(billLine.taxPrice)) {
                    var _adValoremTotal = globalFn.Mul(billLine.quantity, billLine.taxPrice)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_adValoremTotal - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_adValoremTotal, billLine.taxRate, _isTax)
                    }
                    billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                    var _amount = globalFn.Sub(_adValoremTotal, billLine.taxAmount)
                    billLine.amount = _toFixed(_amount, 2)
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                }
                if (isAmount(billLine.adValoremTotal) && globalFn.isNullVal(billLine.taxPrice)) {
                    billLine.taxPrice = globalFn.Div(billLine.adValoremTotal, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(billLine.adValoremTotal - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(billLine.adValoremTotal, billLine.taxRate, _isTax)
                    }
                    var _amount = globalFn.Sub(billLine.adValoremTotal, billLine.taxAmount)
                    billLine.amount = _toFixed(_amount, 2)
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                }
                calTotalAmtTotalTaxamt()
            } else {
                if (!isQuantity(billLine.quantity)) {
                    billLine.quantity = ''
                    logger.logError('数量为负数，整数部分不能大于12个数字，小数部分不能大于15个数字')
                    return
                }
                if (isPrice(billLine.price)) {
                    var _amount = globalFn.Mul(billLine.quantity, billLine.price)
                    billLine.amount = _toFixed(_amount, 2)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_amount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_amount, billLine.taxRate, _isTax)
                    }
                    var _adValoremTotal = globalFn.Add(_amount, billLine.taxAmount)
                    billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                    billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                }
                if (isAmount(billLine.amount) && globalFn.isNullVal(billLine.price)) {
                    var _amount = billLine.amount
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_amount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_amount, billLine.taxRate, _isTax)
                    }
                    var _adValoremTotal = globalFn.Add(_amount, billLine.taxAmount)
                    billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                    billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                }
                calTotalAmtTotalTaxamt()
            }
        }

        // 单价变化
        $scope.priceChange = function ($index) {
            const _isTax = $scope.param.isTax
            const billLine = $scope.param.ovatRedDetailDTOList[$index]
            if (billLine.taxRate == '10.02' && (billLine.price || billLine.taxPrice)) {
                billLine.price = ''
                billLine.taxPrice = ''
                logger.logError('请先修改税率！')
                return
            }
            if (isTax()) {
                if (billLine.taxRate === '') {
                    billLine.price = ''
                    billLine.taxPrice = ''
                    logger.logError('请先录入商品！')
                    return
                }
                if (globalFn.isNullVal(billLine.taxPrice)) {
                    billLine.taxPrice = ''
                    billLine.price = ''
                    return
                }
                billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                if (!isPrice(billLine.taxPrice)) {
                    billLine.taxPrice = ''
                    billLine.price = ''
                    logger.logError('单价整数部分不能大于12个数字，小数部分不能大于15个数字且不能小于等于0')
                    return
                }
                if (isQuantity(billLine.quantity)) {
                    var _adValoremTotal = globalFn.Mul(billLine.quantity, billLine.taxPrice)
                    billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_adValoremTotal - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_adValoremTotal, billLine.taxRate, _isTax)
                    }
                    var _amount = globalFn.Sub(_adValoremTotal, billLine.taxAmount)
                    billLine.amount = _toFixed(_amount, 2)
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                }
                if (globalFn.isNullVal(billLine.quantity) && isAmount(billLine.adValoremTotal)) {
                    var _adValoremTotal = billLine.adValoremTotal
                    billLine.quantity = globalFn.Div(_adValoremTotal, billLine.taxPrice)
                    billLine.quantity = globalFn.cutOutNnumber(billLine.quantity, 15)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_adValoremTotal - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_adValoremTotal, billLine.taxRate, _isTax)
                    }
                    var _amount = globalFn.Sub(_adValoremTotal, billLine.taxAmount)
                    billLine.amount = _toFixed(_amount, 2)
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                }
                calTotalAmtTotalTaxamt()
            } else {
                if (billLine.taxRate === '') {
                    billLine.price = ''
                    billLine.taxPrice = ''
                    logger.logError('请先录入商品！')
                    return
                }
                if (globalFn.isNullVal(billLine.price)) {
                    billLine.taxPrice = ''
                    billLine.price = ''
                    return
                }
                billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                if (!isPrice(billLine.price)) {
                    billLine.price = ''
                    billLine.taxPrice = ''
                    logger.logError('单价整数部分不能大于12个数字，小数部分不能大于15个数字且不能小于等于0')
                    return
                }
                if (isQuantity(billLine.quantity)) {
                    var _amount = globalFn.Mul(billLine.quantity, billLine.price)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_amount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_amount, billLine.taxRate, _isTax)
                    }
                    var _adValoremTotal = globalFn.Add(_amount, billLine.taxAmount)
                    billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                    billLine.amount = _toFixed(_amount, 2)
                    billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                }
                if (globalFn.isNullVal(billLine.quantity) && isAmount(billLine.amount)) {
                    var _amount = billLine.amount
                    billLine.quantity = globalFn.Div(_amount, billLine.price)
                    billLine.quantity = globalFn.cutOutNnumber(billLine.quantity, 15)
                    if (hasBalanced()) {
                        billLine.taxAmount = taxCalculation(_amount - billLine.balance, billLine.taxRate, _isTax)
                    } else {
                        billLine.taxAmount = taxCalculation(_amount, billLine.taxRate, _isTax)
                    }
                    var _adValoremTotal = globalFn.Add(_amount, billLine.taxAmount)
                    billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                    billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                }
                calTotalAmtTotalTaxamt()
            }
        }

        // 金额变化
        $scope.amountChange = function ($index) {
            const _isTax = $scope.param.isTax
            const billLine = $scope.param.ovatRedDetailDTOList[$index]
            if (isTax()) {
                if (billLine.taxRate === '') {
                    billLine.adValoremTotal = ''
                    billLine.amount = ''
                    logger.logError('请先录入商品！')
                    return
                }
                if (globalFn.isNullVal(billLine.adValoremTotal)) {
                    billLine.adValoremTotal = ''
                    billLine.amount = ''
                    return
                }
                billLine.adValoremTotal = _toFixed(globalFn.cutOutNnumber(billLine.adValoremTotal, 2), 2)
                var _adValoremTotal = billLine.adValoremTotal
                if (!isAmount(billLine.adValoremTotal)) {
                    billLine.adValoremTotal = ''
                    billLine.amount = ''
                    logger.logError('金额为负数，整数部分不能大于12个数字，小数部分不能大于2个数字')
                    return
                }
                if (hasBalanced()) {
                    billLine.taxRate != '10.02' && (billLine.taxAmount = taxCalculation(_adValoremTotal - billLine.balance, billLine.taxRate, _isTax))
                } else {
                    billLine.taxRate != '10.02' && (billLine.taxAmount = taxCalculation(_adValoremTotal, billLine.taxRate, _isTax))
                }
                var _amount = globalFn.Sub(_adValoremTotal, billLine.taxAmount)
                billLine.amount = _toFixed(_amount, 2)
                if (isPrice(billLine.taxPrice) && globalFn.isNullVal(billLine.quantity)) {
                    billLine.quantity = globalFn.Div(_adValoremTotal, billLine.taxPrice)
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.quantity = globalFn.cutOutNnumber(billLine.quantity, 15)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                }
                if (isQuantity(billLine.quantity)) {
                    billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                }
                calTotalAmtTotalTaxamt()
            } else {
                if (billLine.taxRate === '') {
                    billLine.adValoremTotal = ''
                    billLine.amount = ''
                    logger.logError('请先录入商品！')
                    return
                }
                if (globalFn.isNullVal(billLine.adValoremTotal)) {
                    billLine.adValoremTotal = ''
                    billLine.amount = ''
                    return
                }
                billLine.amount = _toFixed(globalFn.cutOutNnumber(billLine.amount, 2), 2)
                var _amount = billLine.amount
                if (!isAmount(billLine.amount)) {
                    billLine.amount = ''
                    billLine.adValoremTotal = ''
                    logger.logError('金额为负数，整数部分不能大于12个数字，小数部分不能大于2个数字')
                    return
                }
                if (hasBalanced()) {
                    billLine.taxRate != '10.02' && (billLine.taxAmount = taxCalculation(_amount - billLine.balance, billLine.taxRate, _isTax))
                } else {
                    billLine.taxRate != '10.02' && (billLine.taxAmount = taxCalculation(_amount, billLine.taxRate, _isTax))
                }
                var _adValoremTotal = globalFn.Add(_amount, billLine.taxAmount)
                billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                if (isPrice(billLine.price) && globalFn.isNullVal(billLine.quantity)) {
                    billLine.quantity = globalFn.Div(_amount, billLine.price)
                    billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                    billLine.quantity = globalFn.cutOutNnumber(billLine.quantity, 15)
                }
                if (isQuantity(billLine.quantity)) {
                    billLine.price = globalFn.Div(_amount, billLine.quantity)
                    billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                    billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                    billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                }
                calTotalAmtTotalTaxamt()
            }
        }

        // 税率变化
        $scope.taxRateChange = function ($index) {
            $timeout(() => {
                {
                    const _isTax = $scope.param.isTax
                    const billLine = $scope.param.ovatRedDetailDTOList[$index]
                    const {
                        taxRateObj
                    } = billLine
                    billLine.taxRate = taxRateObj.taxRate
                    billLine.isPrivilege = taxRateObj.isPrivilege
                    billLine.privilegeType = taxRateObj.privilegeType
                    if (billLine.taxRate === '') {
                        billLine.amount = ''
                        billLine.adValoremTotal = ''
                        return
                    }
                    billLine.isPrivilege = taxRateObj.isPrivilege
                    billLine.privilegeType = taxRateObj.privilegeType
                    // 零税率标识
                    if (billLine.taxRate === 0) {
                        billLine.zeroTax = '3'
                    } else {
                        billLine.zeroTax = ''
                    }
                    if (isTax()) {
                        if (!isAmount(billLine.adValoremTotal)) {
                            billLine.adValoremTotal = ''
                            billLine.amount = ''
                            return
                        }
                        if (hasBalanced()) {
                            billLine.taxAmount = taxCalculation(billLine.adValoremTotal - billLine.balance, billLine.taxRate, _isTax)
                        } else {
                            billLine.taxAmount = taxCalculation(billLine.adValoremTotal, billLine.taxRate, _isTax)
                        }
                        const _amount = globalFn.Sub(billLine.adValoremTotal, billLine.taxAmount)
                        billLine.amount = _toFixed(_amount, 2)
                        // 不含税单价
                        if (isQuantity(billLine.quantity)) {
                            billLine.price = globalFn.Div(_amount, billLine.quantity)
                            billLine.price = globalFn.cutOutPnumber(billLine.price, 15)
                        }
                    } else {
                        if (!isAmount(billLine.amount)) {
                            billLine.adValoremTotal = ''
                            billLine.amount = ''
                            return
                        }
                        if (hasBalanced()) {
                            billLine.taxAmount = taxCalculation(billLine.amount - billLine.balance, billLine.taxRate, _isTax)
                        } else {
                            billLine.taxAmount = taxCalculation(billLine.amount, billLine.taxRate, _isTax)
                        }
                        const _adValoremTotal = globalFn.Add(billLine.amount, billLine.taxAmount)
                        billLine.adValoremTotal = _toFixed(_adValoremTotal, 2)
                        // 含税单价
                        if (isQuantity(billLine.quantity)) {
                            billLine.taxPrice = globalFn.Div(_adValoremTotal, billLine.quantity)
                            billLine.taxPrice = globalFn.cutOutPnumber(billLine.taxPrice, 15)
                        }
                    }
                    calTotalAmtTotalTaxamt()
                }
            })
        }

        function checkRedInfo() {
            if ($scope.param.applicant !== '1' && (!blueflag && ($scope.param.remark.indexOf($scope.invoiceCodeLabel) == -1 ||
                    $scope.param.remark.indexOf($scope.invoiceNumberLabel) == -1 || $scope.param.blueInvoiceCode == null ||
                    $scope.param.blueInvoiceCode == '' || $scope.param.blueInvoiceNumber == null || $scope.param.blueInvoiceNumber == ''))) {
                logger.logError('红票未选择对应蓝票，或备注内容有误，不允许开具！')
                return false
            }
            // 蓝票红冲发票备注及蓝票代码号码校验
            if ($scope.param.applicant !== '1' && blueflag) {
                let blueInvoice = utils.getBlueInvoiceFromRemark({
                    remarks: $scope.param.remark,
                    invoiceCodeLabel: $scope.invoiceCodeLabel,
                    invoiceNumberLabel: $scope.invoiceNumberLabel
                })
                if (blueInvoice.blueInvoiceCode != $scope.param.blueInvoiceCode || blueInvoice.blueInvoiceNumber != $scope.param.blueInvoiceNumber) {
                    logger.logError('红票备注内容发票代码号码不是所选的对应蓝票代码号码，不允许开具！')
                    return false
                }
            }
            if ($scope.param.applicant !== '1' && (!invoiceCodeReg.test($scope.param.blueInvoiceCode) || !invoiceNumReg.test($scope.param.blueInvoiceNumber))) {
                logger.logError('请备注正确的发票代码、号码')
                return false
            }
            if ($scope.param.applicant !== '1' && ($scope.param.blueInvoiceCode == '' && $scope.param.blueInvoiceNumber == '')) {
                logger.logError('发票代码号码为空，不允许开具！')
                return false
            }
            if (blueflag && globalFn.Sub(Math.abs($scope.param.totalAmt), Math.abs(redAmount)) > 0) {
                logger.logError('红冲金额不能超过对应蓝票可红冲的金额！')
                return false
            }
            if (blueflag && globalFn.Sub(Math.abs($scope.param.totalTaxamt), Math.abs(redTax)) > 0) {
                logger.logError('红冲总税额不能超过对应蓝票可红冲的税额！')
                return false
            }
            if ($scope.param.infoCode !== '' && !isInfoCode($scope.param.infoCode)) {
                logger.logError('红字信息表编号为16位数字')
                return false
            }
            if (!checkGoodsTr()) {
                return false
            }
            return true
        }

        // 生成红字信息表
        function makeRedInfo(c, n) {
            httpRequest.post_checkOvatInvoiceList({
                invoiceCode: c,
                invoiceNumber: n,
                redApplicantType: $scope.param.applicant
            }).then((res1) => {
                if (res1.data.value) {
                    httpRequest.post_getRedInfoByBlueInvoice({
                        blueInvoiceCode: c,
                        blueInvoiceNumber: n,
                        redApplicantType: $scope.param.applicant
                    }).then((res) => {
                        // 回写干啥
                        const _res = res.data
                        if (!_res.success) {
                            blueBill = $scope.param
                            // 红冲备注
                            $scope.param.remark = `${$scope.invoiceCodeLabel}:${c}${$scope.invoiceNumberLabel}:${n}`
                            logger.logError(_res.message)
                            return
                        }
                        const item = _res.value
                        blueBill = item
                        // 当信息选择为“购买方申请-发票未抵扣”时，根据输入的发票号码代码去查找发票如果当前税号不是作为购方
                        if ($scope.param.applicant === '2' && item.custCreditCode !== $scope.param.custCreditCode) {
                            logger.logError('票面中的税号与当前所用组织的税号不一致，请检查！')
                            return
                        }
                        // infoid
                        $scope.param.infoId = item.infoId
                        // 销方信息
                        $scope.param.saleAddress = (item.saleAddress + ' ' + item.salePhone).trim()
                        $scope.param.salePhone = ''
                        $scope.param.saleBank = (item.saleBank + ' ' + item.saleBankAccount).trim()
                        $scope.param.saleBankAccount = ''
                        $scope.param.saleCreditCode = item.saleCreditCode
                        $scope.param.saleId = item.saleId
                        $scope.param.saleName = item.saleName
                        // 商品明细
                        $scope.param.ovatRedDetailDTOList = item.ovatRedDetailDTOList
                        // 是否清单
                        $scope.param.isBlueList = item.isBlueList
                        // 购方信息
                        $scope.param.custAddress = item.custAddress
                        $scope.param.custBank = item.custBank
                        $scope.param.custBankAccount = item.custBankAccount
                        $scope.param.custCreditCode = item.custCreditCode
                        $scope.param.custMobile = item.custMobile
                        $scope.param.custName = item.custName
                        $scope.param.custPhone = item.custPhone
                        $scope.param.creditType = item.creditType

                        // 收款人
                        $scope.param.payee = item.payee

                        $scope.param.blueInvoiceCode = item.invoiceCode
                        $scope.param.blueInvoiceNumber = item.invoiceNumber

                        // 可红冲金额
                        redAmount = item.redAmount
                        redTax = item.redTax

                        // 红冲备注
                        $scope.param.remark = `${$scope.invoiceCodeLabel}:${item.invoiceCode}${$scope.invoiceNumberLabel}:${item.invoiceNumber}`
                        // 判断是否差额发票
                        const goodsTr = item.ovatRedDetailDTOList
                        if ((goodsTr.length == 1 || goodsTr.length == 2) && goodsTr[0].balance != 0 && goodsTr[0].balance != null) {
                            $scope.param.ovatRedDetailDTOList[0].balance = $scope.param.ovatRedDetailDTOList[0].balance
                            $scope.param.remark = `差额征税。${$scope.param.remark}`
                        }
                        blueflag = true
                        // 接口已处理负数问题
                        // 此处只处理小数点问题
                        const {
                            ovatRedDetailDTOList
                        } = $scope.param
                        if (ovatRedDetailDTOList != null && ovatRedDetailDTOList != undefined && ovatRedDetailDTOList.length != 0) {
                            for (let i = 0, l = ovatRedDetailDTOList.length; i < l; i++) {
                                getGoodsInfoTax(ovatRedDetailDTOList[i].revenueCode, ovatRedDetailDTOList[i].privilegeType, i)
                                ovatRedDetailDTOList[i].amount = _toFixed(ovatRedDetailDTOList[i].amount, 2)
                                ovatRedDetailDTOList[i].adValoremTotal = _toFixed(ovatRedDetailDTOList[i].adValoremTotal, 2)
                                ovatRedDetailDTOList[i].taxAmount = _toFixed(ovatRedDetailDTOList[i].taxAmount, 2)
                            }
                        }
                        calTotalAmtTotalTaxamt()
                    }, (err) => {
                        blueBill = $scope.param
                        // 红冲备注
                        $scope.param.remark = `${$scope.invoiceCodeLabel}:${c}${$scope.invoiceNumberLabel}:${n}`
                    })
                } else {
                    blueBill = $scope.param
                    // 红冲备注
                    $scope.param.remark = `${$scope.invoiceCodeLabel}:${c}${$scope.invoiceNumberLabel}:${n}`
                }

            }, (err) => {
                blueBill = $scope.param
                // 红冲备注
                $scope.param.remark = `${$scope.invoiceCodeLabel}:${c}${$scope.invoiceNumberLabel}:${n}`
            })
        }

        function validateRemark(invoice, hasBalance) {
            if (hasBalance) {
                if (invoice.remark.indexOf('差额征税。') === -1) {
                    return '差额征税备注有误'
                }
            }
            const blueInvoice = utils.getBlueInvoiceFromRemark({
                remarks: invoice.remark,
                invoiceCodeLabel: $scope.invoiceCodeLabel,
                invoiceNumberLabel: $scope.invoiceNumberLabel
            })
            if (!invoiceCodeReg.test(blueInvoice.blueInvoiceCode) ||
                !invoiceNumReg.test(blueInvoice.blueInvoiceNumber)) {
                return '请备注正确的发票代码、号码'
            }
            return ''
        }
        // 红冲备注变化
        $scope.remarkChange = function () {
            if ($scope.param.applicant === '1') {
                return
            }
            if (!$scope.param.remark) {
                $scope.param.remark = `${$scope.invoiceCodeLabel}:${$scope.param.blueInvoiceCode}${$scope.invoiceNumberLabel}:${$scope.param.blueInvoiceNumber}`
                return
            }
            const error = validateRemark($scope.param, hasBalanced())
            if (error) {
                logger.logError(error)
            }
            const blueInvoice = utils.getBlueInvoiceFromRemark({
                remarks: $scope.param.remark,
                invoiceCodeLabel: $scope.invoiceCodeLabel,
                invoiceNumberLabel: $scope.invoiceNumberLabel
            })
            // 和上次的蓝票号码代码相同则不查询蓝票信息
            if ($scope.param.blueInvoiceCode === blueInvoice.blueInvoiceCode &&
                $scope.param.blueInvoiceNumber === blueInvoice.blueInvoiceNumber) {
                return
            }
            Object.assign($scope.param, blueInvoice)
            // 查询蓝票信息
            makeRedInfo($scope.param.blueInvoiceCode, $scope.param.blueInvoiceNumber)
        }

        // 删除商品行
        $scope.operatedMinus = function () {
            const _idList = $scope.selectedRows
            if (_idList.length > 0) {
                let msg = ''
                let minusCallback
                if (hasBalselectedArr($scope.param.ovatRedDetailDTOList, 'selected')) {
                    msg = '该行包含差额，确定删除？?'
                    minusCallback = function () {
                        for (let i = 0, l = _idList.length; i < l; i++) {
                            for (const a in $scope.param.ovatRedDetailDTOList) {
                                if ($scope.param.ovatRedDetailDTOList[a].serialNo === _idList[i]) {
                                    $scope.param.ovatRedDetailDTOList.splice(a, 1)
                                    $scope.param.remark = $scope.param.remark.replace('差额征税。', '')
                                }
                            }
                        }
                    }
                } else {
                    msg = '确认删除这些商品吗?'
                    minusCallback = function () {
                        for (let i = 0, l = _idList.length; i < l; i++) {
                            for (const a in $scope.param.ovatRedDetailDTOList) {
                                if ($scope.param.ovatRedDetailDTOList[a].serialNo === _idList[i]) {
                                    $scope.param.ovatRedDetailDTOList.splice(a, 1)
                                }
                            }
                        }
                    }
                }

                // 弹出确认框

                sweetalert.swal({
                    title: '删除提醒',
                    text: msg,
                    // type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#0096e7',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }, (isConfirm) => {
                    if (isConfirm) {
                        // 确定处理
                        $scope.selectedRows = []
                        minusCallback()
                        calTotalAmtTotalTaxamt()
                    }
                })
            } else {
                logger.logError('请先选择商品')
            }
        }


        // 新增提交
        // 是否暂存成功
        $scope.isSubmited = false
        $scope.isOnSubmit = false
        if ($scope.param.workflowStatus == '3') {
            $scope.isSubmited = true
        }
        $scope.submit = function () {
            const msg = '提交成功'
            if (!checkRedInfo()) {
                return
            }

            buyerChecker.checkBuyerCreditCode($scope.param.custCreditCode, $scope.param.creditType).then(() => {
                matNameAndRate()
                // 提交
                $scope.param.isSubmit = '1'
                $scope.param.ovatRedDetailDTOList = altIsTaxArr($scope.param.ovatRedDetailDTOList, $scope.param.isTax)
                $scope.isOnSubmit = true

                httpRequest.post_checkOvatInvoiceList({
                    invoiceCode: $scope.param.blueInvoiceCode,
                    invoiceNumber: $scope.param.blueInvoiceNumber,
                    redApplicantType: $scope.param.applicant
                }).then((res1) => {
                    // 没有蓝票
                    if (!res1.data.value && $scope.isSubmited) {
                        // 确认弹窗
                        window.layer.open({
                            type: 1, // Page层类型
                            title: '提交确认',
                            closeBtn: 0,
                            shade: 0.6, // 遮罩透明度
                            btn: ['确定', '取消'], // 按钮
                            maxmin: false, // 允许全屏最小化
                            anim: 0, // 0-6的动画形式，-1不开启
                            content: '本地没有找到对应蓝票，是否要提交？',
                            yes(index) {
                                window.layer.close(index)
                                addRedInfoFunc(msg)
                            },
                            cancel(index) {
                                layer.close(index)
                                $scope.isOnSubmit = false
                            },
                        })
                    } else {
                        // 有蓝票
                        addRedInfoFunc(msg)
                    }
                })
            })
        }

        // 暂存
        $scope.scratch = function () {
            const msg = '暂存成功'
            // 红字普通发票备注及蓝票代码号码校验
            if (!checkRedInfo()) {
                return
            }

            buyerChecker.checkBuyerCreditCode($scope.param.custCreditCode, $scope.param.creditType).then(() => {
                matNameAndRate()

                // 暂存还是提交
                $scope.param.ovatRedDetailDTOList = altIsTaxArr($scope.param.ovatRedDetailDTOList, $scope.param.isTax)
                $scope.isOnSubmit = true
                addRedInfoFunc(msg, true)
            })
        }
        // 提交接口
        function addRedInfoFunc(msg, isScratch) {
            let params = {
                ...$scope.param
            }
            if ($scope.param.applicant === '1') {
                params.remark = ''
            }
            httpRequest.post_addRedInfo(params, msg).then((res) => {
                $scope.isOnSubmit = false
                const result = res.data.value
                $scope.param.infoId = result.infoId
                if (isScratch) {
                    $scope.param.remark = result.remark
                    return
                }
                if (result.workflowStatus === '3' && $scope.param.infoStatus !== 'TZD0000') {
                    sweetalert.confirm('上传税局', '提交成功，是否需要现在上传税局？您也可以稍后在列表页面上传税局').then(() => {
                        // if (checkSoapBeforeTaxCore()) return
                        utils.loading('正在上传, 请稍候')
                        if (!result.ukeyId && result.ukeyId !== 0) {
                            const ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
                            const ukey = ukeyList.filter(i => {
                                return i.diskCode == localStorage.currentDiskCode && i.manageType == '0'
                            })
                            if (ukey.length) {
                                result.ukeyId = ukey[0].ukeyId
                            } else {
                                result.ukeyId = ukeyList[0].ukeyId
                            }
                        }
                        redInfoService.upload([$scope.param.infoId], result.ukeyId).then(null, (err) => {
                            logger.logError(err)
                        }).finally(() => {
                            utils.loaded()
                            $state.go('outputManage.FOManage.redInfo.list')
                        })
                    }, () => {
                        $state.go('outputManage.FOManage.redInfo.list')
                    })
                } else {
                    $state.go('outputManage.FOManage.redInfo.list')
                }
            }, () => {
                $scope.isOnSubmit = false
            })
        }

        // 转一下含税标志
        function altIsTaxArr(arr, isTax) {
            const newArr = []
            const o = arr
            for (const m in o) {
                o[m].isTax = isTax
                newArr.push(o[m])
            }
            return newArr
        }

        // post_getRedInfoListByIds

        // 打印预览
        $scope.printPreview = function () {
            // 弹窗
            const balanceModalData = []
            balanceModalData.push($scope.param) // 数据
            const modalInstance = $uibModal.open({
                template: require('./view/printPreview.html'),
                controller: 'modalPrintCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-print mod-modal mod-modal-lg',
                resolve: {
                    items1() {
                        return balanceModalData
                    },
                    items2() {
                        return $scope.dictData
                    },
                },
            })
            modalInstance.result.then((item) => {
                console.log(item)
            }, () => {
                console.log(`Modal dismissed at: ${new Date()}`)
            })
        }

        // 获取选中id数组
        function getSelectedArr(arr, oldid, newid) {
            const selectedArr = []
            const o = arr
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid]) {
                    selectedArr.push(o[m][newid])
                }
            }
            return selectedArr
        }
        // 是否含有差额
        function hasBalselectedArr(arr, oldid) {
            const selectedArr = []
            const o = arr
            let fl = false
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid] && (o[m].balance !== 0 && o[m].balance !== null)) {
                    fl = true
                    break
                }
            }
            return fl
        }
        // 选择行金额是否合法
        function hasUnAmountArr(arr, oldid) {
            const selectedArr = []
            const o = arr
            let fl = false
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid] && !isAmount(o[m].amount)) {
                    fl = true
                    break
                }
            }
            return fl
        }
    }
}

editRedInfoCtrl.$inject = ['$scope', '$http', '$uibModal', '$location', 'logger', 'httpRequest', '$state', 'sweetalert', 'globalFn', 'redInfoService', 'operationService', 'buyerChecker', '$timeout']
export default editRedInfoCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/editRedInfoCtrl.js